/* --------------------------------------------------------------------------------------
   setPin.component.js
   Copyright © 2018 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

export const setPinComponent  = {
    template: require('./setPin.html'),
    controller: 'setPinCtrl',
    controllerAs: 'vm',
    bindings: {
      refresh: '<',
      back: '&'
    }
}

export class setPinCtrl {
  /*@ngInject*/
  constructor(commonService, appService, dataService, userService, $state, $translate) {
    this.commonService = commonService
    this.appService = appService
    this.$state = $state
    this.dataService = dataService
    this.userService = userService
    this.$translate = $translate
  }
  $onInit () {
    this.commonService.setDefaultBackground()
    this.setKeypad()
  }
  $onChanges() {
    let newUserToken = this.appService.getNewUserToken()
    if (newUserToken)
      this.dataService.getUserFullName(newUserToken.token)
        .then(result => {
          this.user = {
            user64: newUserToken.user,
            name: result.Value,
            accesstoken64: newUserToken.token.access_token_64,
            refreshtoken64: newUserToken.token.refresh_token_64,
            attempts: 0,
            lastattempt: new Date().getTime()
          }
        })
  }
  submit() {
    try {
      this.user.pin = $("#txtPin").getkeyboard().$preview.val()

      if (this.user.pin.length < 4) {
        this.$translate('SHORT_PIN_ERROR')
        .then(result => {this.error = result})
      }
      else if (this.user.pin) {
        $("#txtPin").getkeyboard().destroy();
        this.userService.setUser(this.user)
          .then(() => this.$state.reload())
          .catch(error => {this.error = error})
      }
      else {
        $("#txtPin").css("border", "1px solid red")
      }
    } catch (err) {
      $("#txtPin").css("border", "1px solid red")
    }
  }
  setKeypad() {
    $('#txtPin').xrxkeyboard({
      initialPlaceholder: "",
      layout: 'xrxNum',
      maxLength: 8,
      theme: 'blue',
      appendLocally: false,
      appendTo: '#pinpadsetpin',
      alwaysOpen: true,
      backgroundSlide: false,
      beforeVisible: (event, keyboard, el) => {
        $(".xrx-keyboard").css("position", "relative");
        $(".xrx-num-accept").css("visibility", "hidden");
        $(".xrx-num-cancel").css("visibility", "hidden");
        $(".xrx-keyboard").css("box-shadow", "none");
        $(".xrx-keyboard").css("border-top", "none");
        $(".xrx-keyboard").css("transition", "width 0s");
        $(".xrx-keyboard").css("padding-top", "0");
        $(".xrx-keyboard").css("padding-bottom", "0");
      },
      change: (event, keyboard, el) => this.removeError()
    });
  }
  removeError () {
    this.error = null
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/components/setPin.component.js